import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import ProcessoService from '@services/ProcessoService';

const useTratamentoCPFTiposPendencia = () => {
    const fetch = useCallback(() => ProcessoService.listarTiposPendenciasTratamentoCPF(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useTratamentoCPFTiposPendencia;
